import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import { parsePrice, addDeliveryAndTip, SplitTax } from '../../../../../../lib/helper.js';
import defaultMsg from '../../../../../../translations/lang/en-US.json';
import OrderItems from './OrderItems';
import Taxes from './Taxes';
import SubTotal from './SubTotal';
import Tip from './Tip';

class ReceiptDetails extends PureComponent {
  addDeliveryAndTip = data => {
    const { amount=0, description } = data;
    const tipAmount = get(description, 'tipAmount', 0);
    return addDeliveryAndTip(amount, tipAmount);
  };

  render() {
    const { order,
            order:{
              description:{
                orderType = '', 
                deliveryFee = 0, 
                discountInfo = '',
                tipAmount = 0, 
                paymentType, 
                cardType,
              }, 
              orderInformation:{
                roundingAmount,
                subtotal,
                checks
              }
            } 
          } = this.props;
    const taxes = SplitTax(get(checks,'[0].taxDetails', {}));

    return (
      <div className="col-md-6">
        <OrderItems items={get(checks,'[0].items', [])} />
        { taxes.inclusiveTaxes.length > 0 ? <Taxes header="Included Tax" taxes={taxes.inclusiveTaxes} /> : null }
        <SubTotal subtotal={subtotal} orderType={orderType} deliveryFee={deliveryFee} discountDetails={discountInfo} />
        { taxes.exclusiveTaxes.length > 0 ? <Taxes header="Tax" taxes={taxes.exclusiveTaxes} /> : null }
        <ul className="list-style">
          <Tip tipAmount={tipAmount} paymentType={paymentType} cardType={cardType} onPayPal={true} />
          {roundingAmount !== 0 && typeof roundingAmount !== 'undefined' ? (
            <li>
              <FormattedMessage
                id="roundingAdjustment"
                defaultMessage={defaultMsg.roundingAdjustment} 
              />
              :
              <span className="pull-right">
                {parsePrice(roundingAmount)}
              </span>
            </li>
          ) : null}
          <li>
            <FormattedMessage id="total" defaultMessage={defaultMsg.total} />
            <span className="pull-right">{this.addDeliveryAndTip(order)}</span>
          </li>
          <Tip tipAmount={tipAmount} paymentType={paymentType} cardType={cardType} onPayPal={false} />
        </ul>
      </div>
    );
  }
}

export default ReceiptDetails;


// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/ReceiptDetails/index.jsx